import { Card } from 'antd';
import Layout from 'Layout'
import './styles.scss'
import { useParams } from "react-router-dom";
import { mixGetV1, mixPostV1, mixPostV3 } from 'services/mixin';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js"
import { Helmet } from 'react-helmet-async';
import { REACT_APP_PAYPAL_MODE } from 'env';
import { useTranslation } from 'react-i18next';

function ProductDetail() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { id } = useParams<{ id: string }>();
    const [userId, setUserId] = useState<number>()
    const [detailData, setDetailData] = useState<any>()
    const [desc, setDesc] = useState<any>()
    const [orderId, setOrderId] = useState<string>('')
    const [paymentId, setPaymentId] = useState<number>()

    const getData = async () => {
        const res = await mixGetV1(`/api/v1/be/products/${id}?locale=${lang}`)

        if (res.status) {
            setDetailData(res.data)
            const getDesc = res.data.description ? JSON.parse(res.data.description) : ''
            setDesc(getDesc)
        }
    }

    // const initialOptions = {
    //     "clientId": "AdphNSOOqYVzVBFbvGgWqPm0z5296JAchw5hl9AiPguR-mGjsqIzxpI699FNbb_g6gWTUHJUMtJCOCVs",
    //     "enable-funding": "venmo",
    //     "disable-funding": "",
    //     "buyer-country": "VN",
    //     currency: "USD",
    //     "data-page-type": "product-details",
    //     components: "buttons",
    //     "data-sdk-integration-source": "developer-studio",
    // };

    const PAYPAL_CLIENT_ID = REACT_APP_PAYPAL_MODE === 'live'
        ? 'AZFX-UaOLaMkQqwVbbt7w0cInOZ5uANZ6UMrh4OY0mL0eA3m_ZSpXt1ubhu6F_Jn9EDbVgKqUIom8ZYH'  // Live
        : 'Abn2V5kg80p1v6NyUR2OnP4cpJ23R1b9sjPmNHKFzQvkcV4yos94dr19y8lJHEsAisLSrXlQzSxQGdxL'; // Sandbox

    const initialOptions = {
        "client-id": PAYPAL_CLIENT_ID,
        "currency": "USD",
        "intent": "capture",
        "components": "buttons",
        "enable-funding": "venmo,paylater",
        "disable-funding": ""
    };


    // const handleBuy = async () => {
    //     const localeData = localStorage.getItem('user')

    //     if (localeData) {
    //         const idData = JSON.parse(localeData).id

    //         const res = await mixPostV1('/api/v1/be/orders/purchase-with-points', {
    //             "user_id": idData,
    //             "product_id": id
    //         })

    //         if (res.status) {
    //             toast.success('Purched product successful', {
    //                 position: "top-right",
    //                 autoClose: 3000,
    //                 hideProgressBar: false,
    //                 closeOnClick: false,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "light",
    //             });
    //         } else {
    //             toast.error('Purched failed', {
    //                 position: "top-right",
    //                 autoClose: 3000,
    //                 hideProgressBar: false,
    //                 closeOnClick: false,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "light",
    //             });
    //         }
    //     } else {
    //         toast.error('Failed load data locale', {
    //             position: "top-right",
    //             autoClose: 3000,
    //             hideProgressBar: false,
    //             closeOnClick: false,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //             theme: "light",
    //         });
    //     }
    // }

    const scrollToOrderBox = () => {
        document.getElementById("order-box")?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        const localeData = localStorage.getItem('user')

        if (localeData) {
            const idData = JSON.parse(localeData).id
            setUserId(idData)
        }
        getData()
    }, [])

    return (
        <Layout>
            <Helmet>
                <title>{detailData?.title}</title>
                <meta name="description" content={detailData?.subtitle} />
            </Helmet>
            <div className='numer-product-detail'>
                <header>
                    <div className='detail-sub-title'>
                        {desc?.title}
                    </div>
                    <div className='detail-title'>
                        <span>{detailData?.title}</span>
                    </div>
                </header>
                {/* <div className='detail-container' dangerouslySetInnerHTML={{ __html: desc?.description }}></div> */}
                <div className="wrap-section-bodies">
                    {desc?.map((item2: any) => (
                        <div className='section-body'>
                            {item2.title && <h3>{item2.title}</h3>}
                            <div className={`wrap-content-detail ${item2.position === 'Left' && 'left'} ${item2.position === 'Right' && 'right'} ${item2.position === 'Top' && 'top'} ${item2.position === 'Bottom' && 'bottom'}`}>
                                <img src={`${item2.image}`} loading='lazy' alt={item2.title} style={{ display: item2.position === 'NoImage' ? 'none' : 'block' }} />
                                <div className='stask-content-fill' dangerouslySetInnerHTML={{ __html: item2.content }} />
                            </div>
                            {item2.hasButton && (<div className='wrap-button'>
                                <button onClick={scrollToOrderBox}>
                                    <span>Unlock My Personalized Report</span>
                                    <img src="/images/animationclick.gif" loading='lazy' alt="Animation Click" />
                                </button>
                            </div>)}
                        </div>
                    ))}
                </div>
                {/* <div id="order-box" className='order-box'>
                    <Card
                        title={
                            <>
                                Click The Button Below &amp; Pay Only{" "}
                                <span className="price-old " style={{
                                    textDecoration: 'line-through',
                                    textDecorationColor: '#e74c3c',
                                }}>$29.99</span>{" "}
                                <span className="price-new">${detailData?.point_price}</span> For Your Personality Decoder Today
                            </>
                        }
                        variant="borderless"
                        style={{ width: 650 }}
                    >
                        <PayPalScriptProvider options={initialOptions}>
                            <PayPalButtons
                                style={{
                                    shape: "rect",
                                    layout: "vertical",
                                    color: "gold",
                                    label: "paypal",
                                }}
                                createOrder={async () => {
                                    try {
                                        const orderData = await mixPostV1('/api/v1/be/orders/paypal/create', {
                                            user_id: userId,
                                            product_id: Number(id),
                                            return_url: `${window.location.origin}/numerologist-products`,
                                            cancel_url: `${window.location.origin}/numerologist-products/${id}`,
                                            quantity: 1
                                        });

                                        if (orderData?.status) {
                                            setOrderId(orderData.data.order_id);
                                            setPaymentId(orderData.data.payment_id);
                                            return orderData.data.order_id;
                                        } else {
                                            if (!orderData.status && orderData.error.already_purchased) {
                                                toast.error(orderData.error.already_purchased, {
                                                    position: "top-right",
                                                    autoClose: 3000,
                                                    hideProgressBar: false,
                                                    closeOnClick: false,
                                                    pauseOnHover: true,
                                                    draggable: true,
                                                    progress: undefined,
                                                    theme: "light",
                                                });
                                            }
                                            // const errorDetail = orderData?.details?.[0];
                                            // const errorMessage = errorDetail
                                            //     ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                            //     : JSON.stringify(orderData);
                                            // throw new Error(errorMessage);
                                        }
                                    } catch (error: any) {
                                        console.log(error);
                                        toast.error('There is an error, please try again', {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: false,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                            theme: "light",
                                        });
                                        throw error;
                                    }
                                }}
                                onApprove={async (data, actions) => {
                                    try {
                                        // Sử dụng data.orderID trực tiếp, không dùng state
                                        const orderData = await mixPostV1('/api/v1/be/orders/paypal/capture', {
                                            paypal_order_id: orderId,
                                            payment_id: paymentId,
                                        });

                                        const errorDetail = orderData?.data;

                                        if (orderData.status) {
                                            toast.success('Payment successfully', {
                                                position: "top-right",
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: false,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "light",
                                            });
                                        }

                                        console.log(errorDetail);

                                        if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                                            return actions.restart();
                                        } else if (errorDetail) {
                                            // throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
                                            return
                                        } else {
                                            const transaction =
                                                orderData.data;

                                            toast.error(`Transaction ${transaction.status}: ${transaction.capture_id}.`, {
                                                position: "top-right",
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: false,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "light",
                                            });

                                            console.log("Capture result", orderData);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        toast.error(`Sorry, your transaction could not be processed...${error}`, {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: false,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                            theme: "light",
                                        });
                                    }
                                }}
                            />
                        </PayPalScriptProvider>

                        <div className='text mt-2'>
                            <img className='icon-block' src='/images/numerlogist/lock.png' alt='icon-block' />
                            <span>All orders are processed on a secure server</span>
                        </div>
                        <div className='pay-list'>
                            <img className='pay-item' src='/images/numerlogist/method_image_1.png' alt='pay-item' />
                            <img className='pay-item' src='/images/numerlogist/method_image_2.png' alt='pay-item' />
                            <img className='pay-item' src='/images/numerlogist/method_image_3.png' alt='pay-item' />
                            <img className='pay-item' src='/images/numerlogist/method_image_4.jpg' alt='pay-item' />
                        </div>
                        <div className='secure'>
                            <img className='secure-img' src='/images/numerlogist/mcafee-icon.png' alt='secure-img' />
                        </div>
                        <div className='order-info'>
                            <img src='/images/numerlogist/guarantee-1-year.png' className='info-img' alt='info-img' />
                            <span>Order now and you’ll have your complete 36-page Personality Decoder sent to you within seconds. We know you’ll get tremendous value from this detailed analysis but, if for any reason you decide that you're not 100% satisfied with your report, just send us an email at support@numerologist.com within <strong>365 days of your date of purchase</strong> - and we'll refund you, no questions asked.</span>
                        </div>
                    </Card>
                </div> */}
            </div>

            <ToastContainer />
        </Layout>
    );
}

export default ProductDetail;